// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AEUpkLfBcFBRBx {\n  display: block;\n  text-align: center;\n}\n.AEUpkLfBcFBRBx h4 {\n  font-size: 20px;\n  margin: 20px 16px 24px;\n}\n.AEUpkLfBcFBRBx p {\n  font-size: 16px;\n  margin: 0 0 8px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": "AEUpkLfBcFBRBx"
};
export default ___CSS_LOADER_EXPORT___;
